module.exports = __webpack_public_path__ + "img/20200512_163525.a91d6606.jpg";